export default __webpack_public_path__ + "images/9211422827e6fc965d563cc3a20a415f-1_mobile_659x494.webp";